module.exports = __webpack_public_path__ + "static/media/ogimage-unbuilt.aff87861.jpg";